<template>
  <svg
    width="15"
    height="19"
    viewBox="0 0 15 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5625 1.58301H13.4375V17.4163L7.5 13.232L1.5625 17.4163V1.58301Z"
      stroke="#FFC300"
      stroke-width="1.58333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.5625 1.58301H13.4375V6.33301H1.5625V1.58301Z"
      stroke="#FFC300"
      stroke-width="1.58333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
